module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "sp1",
    attrs: {
      "id": "ch2"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cn"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_33",
      "title": "33"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "ct"
  }, [_vm._v("EU Enlargement and LGBT Rights")]), _vm._v(" "), _c('p', {
    staticClass: "cs"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Returning to Europe” and Discovering a New World")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("Between June and December 1989, Communist parties across Eastern Europe were forced out of power in a cascade of popular protest that swept across borders and unmade the Cold War division of Europe. Almost precisely at the midpoint of this process, a much smaller event occurred in Copenhagen’s city hall that highlighted a political-cultural fault line between Europe’s now reuniting halves. On October 1, 11 gay couples participated in a civil ceremony in which the Dutch state legally recognized their relationships, the first time any state had done so. As Kelly Kollman writes, this ceremony “sparked a revolution in how western democracies recognize and regulate the relationships of same-sex couples who live within their borders.”"), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-1",
      "id": "chapter2_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" Over the next decade, many West European states and eventually the EU itself became increasingly committed to promoting LGBT equality, not only in their own societies but also in those of EU-aspirants. Just as postcommunist societies began their “return to Europe”—which took concrete political form in the goal of EU membership—the nature of EU citizenship, and in particular sexual citizenship, was changing.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("This chapter describes how the EU came to embrace policies furthering LGBT equality and then promoted them transnationally through the enlargement process. It addresses three main questions. First, what was the EU’s own path to these policies? Second, how have scholars conceptualized EU leverage in diffusing these policies, and what are the findings in extant empirical analyses of this diffusion in Western Europe and first-wave postcommunist EU applicant-states?"), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-2",
      "id": "chapter2_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" Third, if we extend the geographic scope to include not just first-wave postcommunist EU applicant-states but all of postcommunist Europe, can EU leverage still be shown to significantly influence states’ adoption of LGBT-friendly policies? To be clear, the dependent variable in this chapter is "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_34",
      "title": "34"
    }
  }, [_vm._v("policy, not the organization of activism. Further, in focusing on policy, this analysis makes no claims about policy "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("implementation.")]), _vm._v(" Even if clear EU norms about antidiscrimination policy have emerged, their implementation is in the hands of states, as applicants and then as members.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Even with these caveats, policy change is inherently important, which is why comparative studies of LGBT politics typically take it as the dependent variable."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-3",
      "id": "chapter2_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" However, this chapter’s focus on policy is undertaken for more instrumental reasons, that is, as an indicator of EU leverage. Showing that leverage was a significant factor driving the adoption of LGBT-friendly policies in postcommunist states helps us understand why hard-right backlash (against such EU intervention) occurred. Thus, this chapter furnishes a building block for the subsequent chapters’ analysis of how, via backlash, EU leverage indirectly shaped the organization of LGBT activism. Insofar as inadequate policy implementation reflected backlash, the implementation gap only illustrates the book’s argument.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("The first part of the chapter reviews how the EU developed antidiscrimination provisions regarding sexual orientation through its labor market competencies and then incorporated them as broader rights through jurisprudence, the European Social Charter, and the sponsorship of transnational advocacy networks such as ILGA-Europe. This review of the EU’s own path to LGBT rights shows that its application of leverage in the postcommunist applicant-states, far from being a constant, was itself an evolving force. This insight sets up the periodization used to structure the comparative case studies in "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapters 3")]), _vm._v("–"), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v(", which is based on the strength of EU leverage over applicant-states at different stages in time: preaccession, accession, and postaccession.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("The chapter’s second part describes the mechanisms by which EU leverage brought about significant changes in the legal frameworks of postcommunist applicant-states. Besides describing how such leverage has been conceptualized, it reviews extant empirical research on the relative causal impact of EU leverage vis-à-vis domestic factors in explaining policy variation. After all, a host of domestic factors also shape the policy framework in a given country. To play devil’s advocate against the Europeanization literature, one might argue that variation in the sensitivity of European states’ legal frameworks to LGBT rights is primarily determined by these domestic factors, that the “EU effect” is more “EU artifact.” The record of scholarship shows, however, that in "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_35",
      "title": "35"
    }
  }, [_vm._v("this issue area EU leverage was a strong driver of policy change in first-wave postcommunist EU member-states—much stronger, in fact, than it was in the “old” member-states of Western Europe.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("The chapter’s final section builds on this extant research by extending the analysis beyond first-wave postcommunist member-states to all of postcommunist Europe, that is, to countries that share the same negative legacies regarding homosexuality but vary more widely in their degree of exposure to EU leverage. To preview the results, I find that, where EU leverage is highest, policy frameworks for sexual minorities are better than domestic factors would predict; however, this finding does not hold for the first-wave postcommunist member-states since their accession, reflecting their weaker exposure to EU leverage after that point.")]), _vm._v(" "), _c('p', {
    staticClass: "ah"
  }, [_vm._v("The EU’s Path to LGBT Rights and Their Role in EU Enlargement")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("A broader European LGBT advocacy network can trace its origins at least as far back as the 1950s, when the Dutch group COC (Cultuur- en Ontspanningscentrum) established the International Committee for Sexual Equality (ICSE), but the EU itself came only much later to the field, in the 1990s."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-4",
      "id": "chapter2_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" If we have in mind the exercise of “hard leverage,” the EU’s embrace of LGBT equality was later still—well into the process of Eastern enlargement. That said, the intertwining of a transnational European advocacy network with European-level institutions, both in the EU and the Council of Europe (CoE), was a long-running process."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-5",
      "id": "chapter2_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" Thus, by the time the EU did exercise hard leverage in support of LGBT rights in the postcommunist applicant-states, it did so in concert with an advocacy network that could offer extensive organizational support to domestic activists. Hard leverage and the soft power of transnational advocacy were difficult to separate in practice. From the perspective of domestic hard-right coalitions, the EU’s extension of antidiscrimination norms to LGBT people resembled the leading edge of an expansive agenda."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-6",
      "id": "chapter2_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("When the ICSE was established as an umbrella organization for nationally based “homophile” groups in the 1950s, homosexuality was still taboo even in Western Europe, limiting such groups’ influence on mainstream politics. There were additional, more radically oriented attempts "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_36",
      "title": "36"
    }
  }, [_vm._v("to set up transnational networks in the 1970s, but the first sustained advocacy group—the International Lesbian, Gay, Bisexual, Trans and Intersex Association (ILGA)—was not established until 1978."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-7",
      "id": "chapter2_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" Global in ambition, ILGA was primarily European in practice. From early on, the group saw the institutions driving European integration as allies in lobbying domestic governments for rights."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-8",
      "id": "chapter2_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" In 1981, ILGA supported a resolution in the Assembly of the CoE addressing employment discrimination; in 1984, it worked with the European Parliament’s Committee on Social Affairs to produce the Squarcialupi Report, which made recommendations to establish equal rights for gays and lesbian in all member-states."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-9",
      "id": "chapter2_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" In 1994, this collaboration with the EP led to the Roth Report, which was followed by a “Resolution on equal rights for homosexuals and lesbians in the EC”: though nonbinding, it elevated LGBT rights to new prominence in the EU’s policy agenda."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-10",
      "id": "chapter2_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" The EP became one of ILGA’s biggest allies, especially with the establishment of the Intergroup on LGBT Rights in 1997, but ILGA had also built links with the European Commission by the early 1990s."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-11",
      "id": "chapter2_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("As the EU became increasingly committed to LGBT rights, ILGA’s organizational development closely tracked milestones in the EU’s own developmental trajectory. In 1996, in the midst of negotiations over the Treaty of Amsterdam, ILGA-Europe was established as a regional branch of ILGA-World “in order to take advantage of emerging European opportunities.”"), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-12",
      "id": "chapter2_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" One year later, the Treaty entered into force, and Article 13 formally granted the EU competence to “take action to combat discrimination based on sex, racial, or ethnic origin, religion or belief, disability, age, or sexual orientation.”"), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-13",
      "id": "chapter2_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" To emphasize its commitment to enforcing this norm, in 1998 the EP warned that it would block the accession of any country that “through its legislation or policies violates the human rights of lesbians and gay men.”"), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-14",
      "id": "chapter2_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" In 2000, the norm was codified as the Employment Framework Directive (2000/78/EC), which mandated legal change in member-states and applicant-states to bring their labor codes into compliance. As one assessment put it, “Given the number of countries and the population affected, the Employment Directive is arguably the most important single legislative initiative in the history of European lesbian, gay, and bisexual rights.”"), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-15",
      "id": "chapter2_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" During this same period, the EU adopted the European Union Charter of Fundamental Rights, which also included explicit nondiscrimination protections cov"), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_37",
      "title": "37"
    }
  }, [_vm._v("ering sexual orientation (Article 21). Joke Swiebel notes that the EU’s are the only internationally binding legal protections for LGBT people."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-16",
      "id": "chapter2_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Alongside this formalization of minority protection norms, the EU supported the continued development of a transnational advocacy network centered around ILGA-Europe. In 2001, ILGA-Europe became an official partner of the European Commission, which, from that year, has also provided the lion’s share of its funding."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-17",
      "id": "chapter2_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" Over time, ILGA-Europe made associates of some 359 organizations located in 44 European countries."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-18",
      "id": "chapter2_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" Included among them are other associations with transnational reach, such as the European Pride Organizers Forum, the Network of European LGBT Families Associations, and the European Forum of LGBT Christian Groups. To this already-rich field, one must also count multi-issue NGOs that have become strongly engaged with LGBT rights, for example, the Open Society Foundations, Amnesty International, and the Helsinki Foundation for Human Rights.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Looking to politics outside the LGBT advocacy network and the institutions with which it is directly engaged, there are numerous indications of the growing salience of LGBT rights in EU politics. They have come to play a role in the EU’s own high politics. Take the example of Rocco Buttiglione, an Italian Christian Democrat who was nominated as EU commissioner for justice, freedom, and security in 2004. The EP rejected the nomination because of Buttiglione’s views on homosexuality, which he had publicly declared a sin."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-19",
      "id": "chapter2_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" Beyond its implications for LGBT-rights advocates, this episode had institutional significance as the first instance in which the EP exercised its veto power over the composition of the Commission."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-20",
      "id": "chapter2_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" The issue’s salience can also be seen in national-level politics in Western Europe, most conspicuously in the wave of national legislation and referenda enacting some form of same-sex unions, even with the support, in some cases, of conservative parties like Britain’s Tories and Germany’s Christian Democrats."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-21",
      "id": "chapter2_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" Allies can be found at the highest levels of national politics: in 2009, for example, British prime minister Gordon Brown vowed to expand same-sex partnerships to Eastern Europe:")]), _vm._v(" "), _c('p', {
    staticClass: "bqs"
  }, [_vm._v("I’m fighting to get all the countries in Europe to recognize civil partnerships carried out in Britain.… We want countries where that hasn’t been the case—especially in Eastern Europe—to recognise them.… [I]f we "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_38",
      "title": "38"
    }
  }, [_vm._v("could show Eastern Europe[,] as well as Western Europe, that this respect for gay people is due, that would be really important."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-22",
      "id": "chapter2_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Corroboration, albeit in the form of condemnation, can be found among social conservatives in Eastern Europe and the former Soviet Union; as the chairman of the Russian parliament’s Foreign Affairs Committee recently claimed, the expansion of gay culture “has now turned into the official policy of the EU.”"), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-23",
      "id": "chapter2_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Of course, one should be careful not to overstate the ascendancy of LGBT rights in EU politics, as the variation in legal rights even among West European countries attests (see "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#fig1_2"
    }
  }, [_vm._v("Figure 1.2")]), _vm._v("). This was true during the EU’s first Eastern enlargement and remains true today: in ILGA-Europe’s 2017 survey of LGBT policies across Europe, Italy and Greece received comparable rankings to most states in postcommunist East Central Europe—and far below the rest of Western Europe."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-24",
      "id": "chapter2_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" There are differences among West European member-states regarding adoption by same-sex couples, the legal definition of same-sex relationships (marriage versus partnerships), and social welfare rights."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-25",
      "id": "chapter2_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" Given this diversity, we should not assume convergence to some common EU policy model in the future, nor should we be surprised by the imperfect implementation of policies adopted as a requirement for accession once membership has been gained.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("That said, by 2000 a clear norm of support for sexual minorities had become entwined in the EU’s sense of its identity and policy mission. Meanwhile, the EU was deeply engaged with another defining mission, enlargement into postcommunist Europe. Reviewing the chronology of the relationship between Eastern Europe’s new democracies and the EU, in 1991 the first “European Agreements” were signed. These set membership as a goal, but they were vague on basic terms such as timelines, requirements, and assistance. At a time when the Cold War division of Germany was ending, optimism for a rapid “return to Europe” reigned. Between 1993 and 1995, the relationship deepened considerably when European Council summits in Copenhagen and Madrid laid out three so-called Copenhagen criteria for applicant-states: (1) stable democratic institutions, (2) a functioning market economy, and (3) the capacity to take on the obligations of membership, including the entire corpus of accumulated EU legislation and regulation known as the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("acquis")]), _vm._v(" "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_39",
      "title": "39"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("communautaire")]), _vm._v(". Implicitly, these bore on the rights of sexual minorities, first, because the European Council’s first criterion mandated that each candidate country achieve “stability of institutions guaranteeing democracy, the rule of law, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("human rights and respect for and protection of minorities")]), _vm._v(".”"), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-26",
      "id": "chapter2_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" Second, by mandating harmonization with the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("acquis")]), _vm._v(", the criteria locked applicant-states into the expanding antidiscrimination provisions in the EU’s labor regulation. Given the still implicit nature of norms pertaining to sexual orientation, however, EU influence was less about leverage and more about leading by example.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("In 1998, the year in which the EU opened accession negotiations with the Czech Republic, Hungary, Poland, Estonia, and Cyprus, the accession process became formalized and began to entail real adjustments by applicant-states—just as EU norms about sexuality were gaining legal force and the European advocacy network was strengthening. Where the will for adjustment to EU norms was weak, the Commission used conditionality to force them. Indeed the label “negotiations” was something of a misnomer, as the asymmetric power balance between applicant- and member-states allowed the latter to dictate terms to the former, demanding stricter policy adjustments than in any earlier enlargement."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-27",
      "id": "chapter2_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" As Andrew Moravcsik and Milada Vachudova write, the negotiations were better described as a “process of checking that the candidates have adopted EU law, chapter by chapter and page by page. The requirements are massive, nonnegotiable, uniformly applied, and closely enforced.”"), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-28",
      "id": "chapter2_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" (Of course, after accession was a different story.) The opening of negotiations was delayed by two years in a second wave of states with a weaker record of democratic reform, comprising Romania, Slovakia, Bulgaria, Latvia, Lithuania, and Malta. This delay only amplified the EU’s leverage, as it signaled possible exclusion from the EU club. During this period, compliance with the Copenhagen Criteria was monitored by the European Commission, which had formidable resources for information gathering, including delegations in each applicant-state. The Commission’s annual reports on “Progress Toward Accession” publicly scolded applicants for norm violations."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-29",
      "id": "chapter2_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("On May 1, 2004, all the above states but Romania and Bulgaria gained EU membership. (Romania and Bulgaria joined in 2007.) At this point, the leverage of EU institutions over member-states weakened drastically. There was no comparable monitoring of compliance with EU norms to "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_40",
      "title": "40"
    }
  }, [_vm._v("that employed before membership, and formal sanction for noncompliance would now be a lengthy and demanding process.")])]), _vm._v(" "), _c('p', {
    staticClass: "ah"
  }, [_vm._v("Leverage and Policy Diffusion in Western Europe and the First-Wave Postcommunist EU Applicants")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("As European integration has deepened and widened, an extensive literature has theorized the channels by which EU policies and norms diffuse to the national level."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-30",
      "id": "chapter2_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" This section reviews this literature and summarizes some of its notable empirical findings. Following the rationalist and constructivist traditions in international relations theory, this literature has emphasized two main channels of transnational influence. The first is “external incentives,” which holds that states adopt EU norms for instrumentally rational reasons—if the payoffs of adoption outweigh the costs."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-31",
      "id": "chapter2_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" The EU influences this calculation both directly, through the use of conditionality, and indirectly, by creating new opportunities and constraints for domestic actors to pursue their interests."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-32",
      "id": "chapter2_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" Specifically, this calculation is shaped by the clarity of EU norms, the magnitude of the reward for compliance, the credibility of the promise of reward, and the leverage of domestic veto players."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-33",
      "id": "chapter2_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" As we have seen above, regarding LGBT rights, these factors had shifted strongly in favor of at least minimal adoption of EU norms by the late 1990s. The EU’s expanding engagement with the issue was increasingly formalized, and the stringency of policy harmonization, especially compared to earlier rounds of EU enlargement, increased the credibility of the promise of membership."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-34",
      "id": "chapter2_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" Finally, the magnitude of accession’s rewards—access to the single market, to investment, to the Structural Funds, to name just a few—maximized the leverage of domestic NGOs and other rights advocates in accession negotiations. These groups could act as policy brokers between national governments and the EU."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-35",
      "id": "chapter2_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" The European Commission sought out their input and formally included them in consultation over policy harmonization. Since states had reputational incentives to signal their commitment to EU norms by “overfulfilling” in symbolically important areas like minority rights, this granted rights advocates extra leverage."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-36",
      "id": "chapter2_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" As described in "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter1"
    }
  }, [_vm._v("Chapter 1")]), _vm._v(", Romania adopted a far more progressive antidiscrimination framework than the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("acquis communautaire")]), _vm._v(" required. This eagerness was motivated, we can safely assume, by the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_41",
      "title": "41"
    }
  }, [_vm._v("country’s poor record of compliance in many other areas, which ultimately delayed its membership by three years.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("The second channel of EU influence, “social learning,” theorizes norm diffusion through a constructivist-oriented logic of appropriateness."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-37",
      "id": "chapter2_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" States become persuaded of the appropriateness of EU norms, a process that is complementary to, and even concurrent with, external incentives."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-38",
      "id": "chapter2_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" Such persuasion occurs through the participation of national-level policy makers and other political elites in EU networks. It also occurs as accession and membership expose countries to transnational networks of domestic and European actors."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-39",
      "id": "chapter2_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" Not only can these networks offer financial support to domestic advocacy groups, they also can help legitimate these groups among otherwise indifferent domestic groups."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-40",
      "id": "chapter2_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" Such transnational support is especially important in postcommunist countries since domestic groups have comparatively fewer resources."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-41",
      "id": "chapter2_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" A recent survey of LGBT organizations in the East European EU-12 and West European EU-15 states found that at least part of the organizational budget came from international sources in 83 percent of the former, compared with 32 percent of the latter. The "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("majority")]), _vm._v(" of the budget came from international sources in 56 percent of the East European groups, compared with only 5 percent of the West European groups."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-42",
      "id": "chapter2_42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("In recent empirical work, Ayoub offers a pathbreaking comparison of transnational leverage’s role in the adoption of LGBT rights in the “old” member-states of Western Europe (EU-15) and the “new” members included in the first wave of (mostly) postcommunist applicant-states (EU-12)."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-43",
      "id": "chapter2_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" Using cross-national data on the membership of domestic LGBT-oriented NGOs in European-level advocacy networks and controlling for the effects of domestic and broader international determinants of rights frameworks, Ayoub finds that the dynamics of rights adoption differ significantly between the “first mover” states of Western Europe and Eastern Europe’s “new adopters.” In the former, the emergence of homosexuality as a political issue was a gradual, primarily bottom-up process; whereas, in the latter, the LGBT-rights issues emerged comparatively recently, largely through the EU accession process. Ayoub’s central finding is that in first-mover states, rights adoption has been driven primarily by domestic factors, especially levels of economic development, and has only marginally been affected by ties with "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_42",
      "title": "42"
    }
  }, [_vm._v("European-level advocacy networks and other transnational channels. New-adopter states present almost the reverse image: they are primarily “dependent on international resources for making new issues visible and are more inclined to see policy adoption as a means to gain external legitimacy and improve reputation.” In short, they “display greater dependence on transnational actors and are more influenced by international channels.”"), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-44",
      "id": "chapter2_44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" Though Ayoub finds weak evidence for the more direct pressure of conditionality, stronger links between European-level advocacy networks, domestic LGBT groups, and states are found to increase the probability that the latter will adopt higher levels of rights."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-45",
      "id": "chapter2_45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Ayoub’s findings strongly confirm the “disruptive” effect of EU accession on the politics of homosexuality in postcommunist societies. For much of society this top-down legal change came as something of a shock. From their perspective, it reflected national politicians responding to incentives from Brussels in consultation with NGO representatives of a historically marginal, even invisible, minority. During the accession negotiations, these NGOs benefited from an unprecedented influx of resources and recognition from abroad, allowing them outsized influence compared with their actual “ground organization,” for example, their grassroots presence, their territorial reach, and their links with domestic allies. As others have noted, a similar narrative could be found across a variety of other areas affected by accession."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-46",
      "id": "chapter2_46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" It should not have been a surprise that shortly "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("after")]), _vm._v(" the EU’s 2004 enlargement a hard-right backlash was one of the first results and that, where societies were more closed, homosexuality quickly became politically salient and LGBT rights came under attack. Looking comparatively across postcommunist Europe, the next chapters explore the different ways in which the right responded to this EU leverage, again "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("after")]), _vm._v(" gaining membership. Where a hard-right coalition mobilized successfully and resorted to antigay policies, it catalyzed a counterresponse by rights activists that led to the now-evident differences in activism across the region.")]), _vm._v(" "), _c('p', {
    staticClass: "ah"
  }, [_vm._v("Extending the Analysis to All of Postcommunist Europe")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Before turning to backlash’s effect on the organization of LGBT activism, however, this chapter’s final section further probes the significance of EU leverage on the diffusion of LGBT-friendly policies. It seeks to "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_43",
      "title": "43"
    }
  }, [_vm._v("build on the extant empirical work by expanding the boundaries beyond the first-wave postcommunist EU applicant-states. To do so, it draws on ILGA-Europe’s Rainbow Index of lesbian, gay, and bisexual policy frameworks, which covers all postcommunist Europe (as well as Western Europe) from 2009 through 2013. Using multivariate analysis, I assess the relative weight of domestic factors and EU leverage in explaining variation in policy protections for sexual minorities.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("One gap in Ayoub’s analysis is that it only includes postcommunist countries that became EU members in the first wave of enlargement (2004–2007). It excludes the rest of the region, which comprises states with widely divergent degrees of exposure to EU leverage. These states may be divided into four groups: EU members,"), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-47",
      "id": "chapter2_47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" candidates and “potential candidates” for membership, participants in the so-called European Neighborhood Policy (ENP), and countries without formal arrangements for deeper integration of any kind. The candidates for membership—Croatia, the former Yugoslav republic of Macedonia, and Turkey—have all opened formal accession negotiations with the Commission. Serbia, Montenegro, Bosnia and Herzegovina, and Albania comprise the “potential candidates” and, like Croatia and Macedonia, are working toward membership through the Stabilization and Accession Process. The ENP offers a measure of integration without a commitment from the EU about future membership and encompasses Armenia, Azerbaijan, Belarus, Georgia, Moldova, and Ukraine. With no such formal agreements with the EU, Russia might be considered a “permanent outsider,” the state at the greatest remove from European integration.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Generally, these additional categories contain states considered “reform laggards” across a host of policy areas, including rights frameworks for sexual minorities. Excluding them from the analysis potentially understates the effect of EU leverage on rights adoption since the truncated sample consists of states that, as was evident even in the 1990s, enjoyed the highest odds of EU membership and, therefore, had less to gain in terms of reputation from adopting legislation benefiting sexual minorities. It makes sense to compare the original new adopters (EU-12) not only against the first-movers (EU-15) but also against later applicants, potential applicants, ENP states, and “outsiders.” Doing so allows us to probe a fuller range of variation in external incentives and social "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_44",
      "title": "44"
    }
  }, [_vm._v("learning as drivers of rights adoption; additionally, it allows us to include a wider range of variation on domestic factors such as economic modernization, since the first-wave applicant-states comprised the more economically developed tier of postcommunist countries. As an important caveat, the Rainbow Index can expand the geographic range of our analysis, but since its time frame is limited (beginning only in 2009), it cannot tell us about the impact of leverage in the first-wave postcommunist applicant-states (the EU 12) "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("before")]), _vm._v(" they became member-states. That said, it can offer insights about policy improvements in these states after membership.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("For the purpose of this analysis, I emphasize the complementarity of external incentives and social learning as components of EU leverage, which is in keeping with the literature but is also necessitated by the absence of comparative data on transnational linkages between EU-level rights groups and domestic ones across postcommunist Europe."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-48",
      "id": "chapter2_48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" To capture EU leverage (as the combined sum of external incentives and social learning pressures), I employ a proxy variable “EU proximity,” which categorizes states into the four groups described above. To describe the theoretical expectations regarding EU proximity’s effect on the quality of rights frameworks across groups, consider first the “outsiders.” Such states effectively have no possibility of accession, which eliminates external incentives to adopt EU norms. Similarly, we would expect little role for social learning. EU-level advocacy networks are unlikely to invest resources where they see little hope of rights gains. There is no role for NGOs as brokers in the absence of any formal integration process between the state and the EU. Last, domestic rights groups cannot effectively shame the authorities for failure to live up to EU norms that they never committed to, even nominally. From both external incentives and social learning perspectives, then, we expect minimal EU leverage.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("At the other end of the spectrum, maximal leverage may be expected in applicant- and potential applicant-states. Among these the “payoff” for compliance (full membership) is much higher than for the other categories, as is the credibility of the EU’s promise of membership itself. For reputational reasons, states may “overfulfil” regarding rights for sexual minorities in order to signal the seriousness of their overall commitment to EU norms. Likewise, we expect the strongest impact of "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_45",
      "title": "45"
    }
  }, [_vm._v("transnational social learning channels in this group: EU-level advocacy networks should invest most heavily in linkages with domestic rights groups where external incentives maximize those groups’ leverage as brokers. Additionally, the prospect of full and equal membership in the EU amplifies the credibility of these NGOs in linking rights with EU principles.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Turning now to the ENP states and the member-states (both postcommunist and West European), here we expect EU leverage to be moderate at best. In ENP states both the potential payoff for rights adoption (less than full membership) and the credibility of the EU’s promise is weaker than it is in applicants and potential applicants."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-49",
      "id": "chapter2_49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" Likewise, we expect less robust linkages between EU- and domestic-level advocacy groups because, by the same logic as above, the comparatively weaker effect of external incentives undercuts the position of domestic NGOs as brokers and lowers the return to transnational groups of investing resources in them. Additionally, we would expect the promise of “second-class membership” to offer weaker footing for advocacy groups attempting to shame states for failure to live up to EU principles. Last, relative to applicants and potential applicants, we should also expect a weaker effect of transnational pressures in EU member-states themselves. This is, after all, the finding in Ayoub’s analysis of rights frameworks in the established member-states of the EU-15. Leverage should also be weaker in the first-wave member-states of postcommunist Europe—that is, after accession. Because the data in the Rainbow Index begin in 2009, however, we can only analyze their policy ratings after accession. Certainly, before joining they faced strong pressures to achieve at least minimum compliance with EU labor market directives. However, the external incentive structure shifts radically after accession: there are no comparable instrumental reasons for additional rights adoption. Further, there is a tendency for transnational advocacy networks to shift attention and resources to the next batch of transition states after the previous ones join the EU."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-50",
      "id": "chapter2_50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])])]), _vm._v(" "), _c('p', {
    staticClass: "bh"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Dependent Variable")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The dependent variable in my analysis is ILGA-Europe’s Rainbow Index, which compares the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("legal")]), _vm._v(" situation of gays, lesbians, and bisexual (LGB) "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_46",
      "title": "46"
    }
  }, [_vm._v("people. Constructed by a team of legal and regional experts, the composite index rates 47 European states in terms of their legislation regarding the rights of LGB people and, to a more limited extent, their practice toward them."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-51",
      "id": "chapter2_51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" Each state receives a score between -4 and 10. Points are given to countries recognizing same-sex partnerships, parenting rights, and homophobia in hate speech/crime legislation. Points are subtracted if states ban same-sex acts, specify unequal age of consent, or if they have violated the rights of LGB people regarding peaceful assembly and freedom of association.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("While clearly a great advance for researchers, the ILGA-Europe index is not without its limitations. First, because it began in 2009, its coverage is limited. My analysis includes the data from 2009 through 2013 since this overlaps most closely with the period covered in the following chapters. Second, the index does not incorporate policies covering transgender people before 2012: it addresses the rights environment for gay, lesbian, and bisexuals only."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-52",
      "id": "chapter2_52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" This makes comparisons between earlier years, when the index contained fewer components, and later years difficult. To allow for such comparisons, I used the coding criteria for the 2010 index to back-code the subsequent years. As a final shortcoming, measures such as ILGA-Europe’s, which attempt to tap multifaceted concepts across different political-cultural contexts, risk flattening complexity and missing important nuances. To take one analogue, the Freedom House’s rankings of democracy are invariably subjected to this critique. Yet democratization scholars continually return to Freedom House data for want of a better substitute and because failing to learn from differences among countries is a loss of its own. The same defense is offered here. By presenting a broad comparison between postcommunist countries at various degrees of proximity to EU leverage, even the purely cross-sectional comparisons in the ILGA-Europe index offer the opportunity to disentangle domestic and transnational effects.")]), _vm._v(" "), _c('div', {
    staticClass: "IMG"
  }, [_c('table', {
    staticClass: "No-Table-Style",
    attrs: {
      "id": "tab2_1"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tchcell1",
    attrs: {
      "colspan": "7"
    }
  }, [_c('p', {
    staticClass: "th"
  }, [_vm._v("T"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ABLE")]), _vm._v(" 2.1. Comparison of Subgroup Means by Proximity to the EU")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tchcell"
  }), _c('td', {
    staticClass: "tchcell"
  }), _c('td', {
    staticClass: "tchcell"
  }), _c('td', {
    staticClass: "tchcell"
  }), _c('td', {
    staticClass: "tchcell"
  }, [_c('p', {
    staticClass: "tch"
  }, [_vm._v("Mean Score on ILGA-Europe Index")])]), _vm._v(" "), _c('td', {
    staticClass: "tchcell"
  }), _c('td', {
    staticClass: "tchcell"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tchcell"
  }), _c('td', {
    staticClass: "tchcell"
  }), _c('td', {
    staticClass: "tchcell"
  }, [_c('p', {
    staticClass: "tch1"
  }, [_vm._v("All Countries")])]), _vm._v(" "), _c('td', {
    staticClass: "tchcell"
  }), _c('td', {
    staticClass: "tchcell"
  }, [_c('p', {
    staticClass: "tch1"
  }, [_vm._v("Western Europe")])]), _vm._v(" "), _c('td', {
    staticClass: "tchcell"
  }), _c('td', {
    staticClass: "tchcell"
  }, [_c('p', {
    staticClass: "tch1"
  }, [_vm._v("Postcommunist Only")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdcell"
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("EU PROXIMITY")])]), _vm._v(" "), _c('td', {
    staticClass: "tdcell"
  }), _c('td', {
    staticClass: "tdcell"
  }), _c('td', {
    staticClass: "tdcell"
  }), _c('td', {
    staticClass: "tdcell"
  }), _c('td', {
    staticClass: "tdcell"
  }), _c('td', {
    staticClass: "tdcell"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdcell"
  }, [_c('p', {
    staticClass: "tdul"
  }, [_vm._v("• Member-states")])]), _vm._v(" "), _c('td', {
    staticClass: "tdcell"
  }), _c('td', {
    staticClass: "tdcell"
  }, [_c('p', {
    staticClass: "td-c"
  }, [_vm._v("4   ")])]), _vm._v(" "), _c('td', {
    staticClass: "tdcell"
  }), _c('td', {
    staticClass: "tdcell"
  }, [_c('p', {
    staticClass: "td-c"
  }, [_vm._v("5.1")])]), _vm._v(" "), _c('td', {
    staticClass: "tdcell"
  }), _c('td', {
    staticClass: "tdcell"
  }, [_c('p', {
    staticClass: "td-c"
  }, [_vm._v("2.2")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdcell"
  }, [_c('p', {
    staticClass: "tdul"
  }, [_vm._v("• Candidates and “potential” candidates")])]), _vm._v(" "), _c('td', {
    staticClass: "tdcell"
  }), _c('td', {
    staticClass: "tdcell"
  }, [_c('p', {
    staticClass: "td-c"
  }, [_vm._v("2.4")])]), _vm._v(" "), _c('td', {
    staticClass: "tdcell"
  }), _c('td', {
    staticClass: "tdcell"
  }, [_c('p', {
    staticClass: "td-c"
  }, [_vm._v("3.5")])]), _vm._v(" "), _c('td', {
    staticClass: "tdcell"
  }), _c('td', {
    staticClass: "tdcell"
  }, [_c('p', {
    staticClass: "td-c"
  }, [_vm._v("2   ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdcell"
  }, [_c('p', {
    staticClass: "tdul"
  }, [_vm._v("• European Neighborhood Policy (ENP)")])]), _vm._v(" "), _c('td', {
    staticClass: "tdcell"
  }), _c('td', {
    staticClass: "tdcell"
  }, [_c('p', {
    staticClass: "td-c"
  }, [_vm._v("–0.3 ")])]), _vm._v(" "), _c('td', {
    staticClass: "tdcell"
  }), _c('td', {
    staticClass: "tdcell"
  }, [_c('p', {
    staticClass: "td-c"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', {
    staticClass: "tdcell"
  }), _c('td', {
    staticClass: "tdcell"
  }, [_c('p', {
    staticClass: "td-c"
  }, [_vm._v("–0.3  ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdcell"
  }, [_c('p', {
    staticClass: "tdul"
  }, [_vm._v("• EU “outsiders”")])]), _vm._v(" "), _c('td', {
    staticClass: "tdcell"
  }), _c('td', {
    staticClass: "tdcell"
  }, [_c('p', {
    staticClass: "td-c"
  }, [_vm._v("2.3")])]), _vm._v(" "), _c('td', {
    staticClass: "tdcell"
  }), _c('td', {
    staticClass: "tdcell"
  }, [_c('p', {
    staticClass: "td-c"
  }, [_vm._v("2.9")])]), _vm._v(" "), _c('td', {
    staticClass: "tdcell"
  }), _c('td', {
    staticClass: "tdcell"
  }, [_c('p', {
    staticClass: "td-c"
  }, [_vm._v("–2   ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdcell"
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("F-test (H"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("0")]), _vm._v("=all groups’ means are equal)")])]), _vm._v(" "), _c('td', {
    staticClass: "tdcell"
  }), _c('td', {
    staticClass: "tdcell"
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("Reject H"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("0")]), _vm._v(" with 95% confidence")])]), _vm._v(" "), _c('td', {
    staticClass: "tdcell"
  }), _c('td', {
    staticClass: "tdcell"
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("Cannot reject H"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("0")])])]), _vm._v(" "), _c('td', {
    staticClass: "tdcell"
  }), _c('td', {
    staticClass: "tdcell"
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("Reject H"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("0")]), _vm._v(" with 99% confidence")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("As a first cut at the relationship between EU leverage and the quality of legal frameworks for sexual minorities, "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter2#tab2_1"
    }
  }, [_vm._v("Table 2.1")]), _vm._v(" presents a comparison of means across the various categories of members, candidates and potential candidates, ENP states, and “outsiders.” It shows that, overall, there is a statistically significant difference in rights between countries depending on their proximity to EU accession."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-53",
      "id": "chapter2_53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" The main difference appears to be between potential and actual members, on the one hand, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_47",
      "title": "47"
    }
  }, [_vm._v("and neighbors and “outsiders,” on the other. Among postcommunist countries, the difference in means between actual and potential members is only 0.2 points and is statistically insignificant.")])]), _vm._v(" "), _c('p', {
    staticClass: "bh"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Independent Variables")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("As described above, EU leverage is captured through the variable “EU proximity,” which categorizes states into members, candidates and potential candidates, ENP states, and outsiders. A purely domestic model of rights frameworks would trace differences among European countries to just a few major factors that have been identified in the literature on the politics of homosexuality: communism’s legacy, religion’s role in society (both national religious tradition and overall religiosity), and the level of economic development."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-54",
      "id": "chapter2_54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" All of these factors relate closely to a more proximate variable, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("attitudes about homosexuality")]), _vm._v(" in society. Because of its close causal proximity to the outcome of legal change, the variable social attitudes is less theoretically satisfying as an explanation; however, I use social attitudes as a proxy indicator of domestic context in the statistical analysis to check the robustness of the results. To measure social attitudes toward homosexuality, I draw on the WVS question asking respondents to place themselves on a 10-point scale whether “Homosexuality is never (1) / always (10) justified.”"), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-55",
      "id": "chapter2_55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" My variable is the mean value of responses by country. A word "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_48",
      "title": "48"
    }
  }, [_vm._v("of caution regarding these data and the religiosity data, which are based on the same source: because the WVS has been conducted over several waves with a changing cast of countries in each wave, it was necessary to combine data from two separate survey waves to construct these variables."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-56",
      "id": "chapter2_56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" For each country I used the most recent data on attitudes toward homosexuality (and religiosity) from before the construction of the ILGA-Europe rights index: these were WVS waves 4 and 5, conducted around 2000 and 2006, respectively. It would have been better to have data from one point in time, but I judged this alternative an acceptable indicator of how countries varied on this deeper political-cultural dimension, especially given the range of variation."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-57",
      "id": "chapter2_57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Ronald Inglehart’s celebrated postmaterialism thesis posits that, as "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("economic development")]), _vm._v(" raises living standards, it reduces the political salience of bread-and-butter economic issues."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-58",
      "id": "chapter2_58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" Increasingly, it predicts, citizens in wealthy societies will turn their political engagement to “values issues” such as environmentalism, multiculturalism, gender equality, and tolerance of homosexuality. The last of these is often seen as the paradigmatic postmaterialist issue."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-59",
      "id": "chapter2_59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" Cross-national studies have consistently confirmed the posited relationship between economic development and attitudes toward homosexuality, including in postcommunist countries."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-60",
      "id": "chapter2_60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" The path of economic development under communism and the subsequent shock of postcommunist transition tended to foster “survival values,” which promote intolerance."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-61",
      "id": "chapter2_61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" Though my dependent variable is the quality of rights, not attitudes, my expectation is that intolerant attitudes are not conducive to expansive minority rights frameworks. Following the literature, I measure economic development through per capita GDP (in 2008 US dollars)."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-62",
      "id": "chapter2_62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" In line with standard practice for countries at very different levels of economic development, I use the logged value of GDP.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Because there are reasons to suspect that communist legacies also affect attitudes toward homosexuality through channels other than economic development, a postcommunist dummy variable is included. The expectation is that postcommunist countries will have worse rights frameworks than the West European countries in the sample, even when controlling for other differences among them. As illustrated in "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#fig1_1"
    }
  }, [_vm._v("Figures 1.1")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#fig1_2"
    }
  }, [_vm._v("1.2")]), _vm._v(", postcommunist countries stand out both for their consistently lower legal freedoms and less tolerant attitudes regarding sexual minorities. This situation reflects "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("communism’s legacy")]), _vm._v(" of de jure "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_49",
      "title": "49"
    }
  }, [_vm._v("and de facto repression of homosexuality. Many communist governments criminalized homosexuality at some period during their tenure. Some, notably the Soviet Union and Romania, maintained this policy until after communism fell. Even in regimes that decriminalized homosexuality before 1989, communism’s legal legacy was one that did not recognize sexual orientation as a category and that lacked a concept of protections against discrimination.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Even if, however, there was some variation in the legal status of homosexuality by the late 1980s, the unofficial sphere of daily practice looked rather similar across countries. Since Stalin, communist governments across the Eastern bloc were socially very conservative, overlaying a “neo-Victorianism” on societies already predominantly traditionalist in their cultural norms."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-63",
      "id": "chapter2_63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" Gays and lesbians faced pervasive discrimination both from the state authorities and the broader society. As one illustration, though homosexuality was never criminalized in Poland, its secret police used the threat of disclosing sexual orientation to blackmail and recruit informants. From 1985 to 1988, Poland’s secret police pursued a crackdown on gay men, “Operation Hyacinth,” which implicated some 11,000 people."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-64",
      "id": "chapter2_64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" The memory of this everyday repression still drives many sexual minorities to hide their orientation and, consequently, not push for greater rights. According to regional activists, this tendency is still quite noticeable today: most LGBT people prefer to develop their own “underground” networks and clubs rather than publicly fight for acceptance. They prefer that activists "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("not")]), _vm._v(" draw attention to LGBT rights, reasoning that making public claims will upset these tacit accommodations with society at large.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Since LGBT rights touch on core doctrinal issues of the major religious faiths in Europe, my domestic model of rights adoption also includes a variable for a country’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("predominant religious tradition")]), _vm._v(": Protestant, Catholic, Orthodox, or Muslim. Even in secularized societies, national religious traditions are institutional templates with wide-ranging effects and long-lasting consequences, especially for legal and political institutions."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-65",
      "id": "chapter2_65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _vm._v(" Pippa Norris and Ronald Inglehart, for example, write that these traditions “imprint themselves” on society “via the major channels of cultural transmission and socialization.”"), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-66",
      "id": "chapter2_66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" Even for the nonreligious in a given society, attitudes toward issues like sexual liberation will be shaped by national religious traditions. To categorize "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_50",
      "title": "50"
    }
  }, [_vm._v("predominant national religious traditions across Europe, I draw on the research of Norris and Inglehart, who divide the continent into Catholic, Protestant, Orthodox, and Islamic traditions based on the plurality religion."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-67",
      "id": "chapter2_67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" In the statistical analysis, this becomes a categorical variable.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("National religious traditions shape society’s attitudes and political values in an institutional, path-dependent way that endures even after secularization has gained hold. By contrast, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("religiosity")]), _vm._v(" captures differences in the degree to which a society’s political values are influenced by religious belief. Secularization is an erosion of religiosity, regardless of national religious tradition. It is generally seen as a component of the shift to a postmaterialist society."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-68",
      "id": "chapter2_68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])]), _vm._v(" In secular societies, people are less attentive to spiritual matters and find religious teachings about sexuality less compelling. Following Norris and Inglehart, I measure religiosity using the WVS question “How important is God in your life?”"), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-69",
      "id": "chapter2_69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" As with the question on tolerance of homosexuality, possible answers range on a scale from 0 (not important) to 10 (very important). My expectation is that countries with high levels of religiosity will, all things being equal, have weaker legal rights frameworks than countries with low religiosity.")]), _vm._v(" "), _c('p', {
    staticClass: "bh"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Analysis and Results")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("This final section presents the results of a multivariate regression analysis of the hypothesis that EU leverage—which is greatest when states are applying, or expect to apply, to become EU members—leads to improvements in national-level LGB rights frameworks. As described earlier, this analysis does not attempt to distinguish between external incentives and social learning mechanisms but considers their effects on the quality of rights to be complementary. The dataset includes 47 states from Western and Eastern Europe, and the dependent variable is each country’s score on the Rainbow Index for each of the five years from 2009 through 2013. EU leverage is captured primarily cross-sectionally (as differences among states at different removes from EU accession) rather than longitudinally (as states move through the stages of accession). (For technical details on the regression analysis, see the "), _c('span', {
    attrs: {
      "href": "#/xhtml/appendix",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix")]), _vm._v(".) The baseline for comparison is states that have no intention of pursuing EU membership, which includes both postcommunist and West European states. To lead with the main conclusion, I find evidence that where EU leverage was "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_51",
      "title": "51"
    }
  }, [_vm._v("strongest (i.e., among applicant- and potential applicant-states) rights frameworks were of higher quality than we would expect based on domestic determinants such as level of economic development, communist legacy, national religious tradition, religiosity, and attitudes toward homosexuality.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter2#tab2_2"
    }
  }, [_vm._v("Table 2.2")]), _vm._v(" presents the results of random effects models of various theoretical specifications. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Model 1")]), _vm._v(" is the bare-bones EU leverage framework, without any control variables to capture domestic context other than a postcommunist dummy variable to account for the fact that the categories “outsider” and “EU member” include both postcommunist and West European cases. Model 1 shows that potential member and member-states have significantly higher scores on the Rainbow Index than the baseline nonaspirant states. Everything else being equal, this boost is, however, not enough to overcome the strongly negative effect of having a communist legacy, the effect of which is roughly double that of EU incentives. This model does not find a statistically significant difference between nonaspirant and ENP states.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Model 2")]), _vm._v(" presents a strictly domestic account of LGB-rights frameworks, using variables highlighted in the extant literature: economic modernization, communist legacy, national religious tradition, and religiosity. Not surprisingly, these factors show a high degree of explanatory power. As expected, greater religiosity is associated with weaker LGB-rights frameworks. Further, countries with Protestant national religious traditions have better rights frameworks than the baseline Orthodox countries; in this model, the effects of Muslim and Catholic religious traditions are indistinguishable from those of Orthodoxy. Also as expected, economic modernization exercises a positive effect on the rights framework. Last, the effect of the communist legacy remains substantively strong and statistically significant even after controlling for the deeper structural features of the societal context just mentioned.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Model 3")]), _vm._v(" brings together the domestic and EU variables. The substantive effect of the domestic variables remains essentially unchanged. This suggests that, generally speaking, the domestic side of the story matters more for the level of rights comparatively. That said, Model 3 does affirm that, in the situation where we would expect Europeanizing pressures to be most powerful—namely, for candidate and potential candidate states—there is a substantively and statistically significant boost to LGB "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_52",
      "title": "52"
    }
  }, [_vm._v("rights beyond what we would expect based on domestic factors alone. For EU member-states, however, this effect washes out after controlling for domestic determinants—a result in line with previous scholarship."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-70",
      "id": "chapter2_70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])]), _vm._v(" In other words, EU membership was not associated with rights levels beyond what we would expect based on domestic factors alone. Among West European member-states, we can interpret this result as reflecting the earlier exposure of these societies to LGB rights contemporaneously with the global movement’s founding and development since the 1970s; consequently, they differ little from West European nonmember-states. Among the postcommunist states that joined in 2004–2007, we can interpret it as indicating a strategy of “minimum-necessary” legal change before accession and little additional change in the period covered in the dataset."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-71",
      "id": "chapter2_71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" As before, among ENP states, which faced weaker and less credible incentives to burnish their rights reputation, we find no significant boost for rights beyond what domestic factors would predict.")])]), _vm._v(" "), _c('p', {
    staticClass: "tab",
    attrs: {
      "id": "tab2_2"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_53",
      "title": "53"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/Table2-2.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Models 4, 5, and 6")]), _vm._v(" are included as a means of validating the analysis above. Instead of using domestic measures of society’s “deep structure” (e.g., religious tradition and economic development), I use a more proximal indicator of societal openness to LGB rights: attitudes toward homosexuality. The logic is intuitive: where public attitudes about homosexuality are tolerant, we expect more developed legal frameworks for sexual minorities. Like Model 2, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Model 4")]), _vm._v(" is a domestic-only look at LGB rights; not surprisingly, it confirms the intuition just described. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Model 5")]), _vm._v(" adds our proxies for EU leverage (cf. Model 3). Interestingly, this model reaffirms a statistically significant rights boost for the category of candidate and potential candidate states; furthermore, this boost is substantively equal to the negative effect of the communist legacy. For this class of states, then, EU leverage can “overcome” communism’s negative legacy regarding sexual minorities’ rights. With regard to the other categories of EU proximity, however, gains in the quality of rights are not statistically significant when controlling for domestic factors.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Last, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Model 6")]), _vm._v(" draws together all the variables from the previous models. As one would expect, including both the proximate and deeper indicators of societal openness washes out much of the statistical significance of some of the domestic variables, though the general direction of the coefficients remains unaffected. For example, attitudes toward homosexuality "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_54",
      "title": "54"
    }
  }, [_vm._v("pick up much of the effect of religiosity. Likewise, the effect of communism’s legacy is attenuated here. It is, thus, all the more striking that the substantive and statistical significance of EU leverage for the category of candidate and potential candidate states is unshaken in Model 6.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("To summarize, this analysis shows support for the positive effect of EU leverage on legal frameworks regarding sexual orientation in postcommunist Europe. More specifically, it shows that the quality of rights in states facing the greatest leverage (i.e., applicants and potential applicants) is higher than we would expect it to be based on domestic factors alone. In line with previous scholarship, however, my analysis cannot discern a corresponding effect for other categories of EU proximity with a high level of confidence. Put differently, the promise of membership has a stronger effect on the quality of rights frameworks than being a member does. Moreover, if the promise lacks credibility, as in the ENP states, its effect on rights is also hard to discern relative to domestic factors.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("As an important caveat, these findings should not be taken as evidence that EU pressures did not force important legal changes in the first round of postcommunist applicant-states, who had become members by the time period covered in this analysis. As a matter of law, they had to make major, often highly controversial, changes to their labor code to prevent discrimination on the basis of sexual orientation. To put this in context, the United States still lacks such federal-level protections, even after the legalization of same-sex marriage. Thus, even the “minimum necessary” changes enacted by the first postcommunist entrants were deeply significant "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("politically")]), _vm._v(". It was common in interviews with Polish rights activists that, even as they expressed frustration that the EU’s effect was not bigger, they declared that the whole of Poland’s legal framework for LGBT people was the result of EU pressure."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-72",
      "id": "chapter2_72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" That EU leverage could have a positive influence on a controversial issue like this is heartening, at least to rights advocates. To opponents, it only confirms their suspicion that European integration threatens national identity, the conception of the family, and traditional values.")]), _vm._v(" "), _c('p', {
    staticClass: "ah"
  }, [_vm._v("Conclusion: Beyond Policy Change, after Accession")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("As this chapter has shown, EU leverage had a significant impact on the adoption of policies benefiting sexual minorities through the accession "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_55",
      "title": "55"
    }
  }, [_vm._v("process, but it also confirmed that such characteristic features of closed society as high religiosity and lagging economic development also depress such policies. Given these results, EU membership itself was bound to unleash a host of questions about these new policies and the activist groups that had lobbied for them, especially in the comparatively closed societies of Poland, Romania, Slovakia, and Hungary. (For the comparatively open Czech Republic, this chapter’s findings do not suggest any obstacles to rights gains after accession.) First, there was the question of implementation: Would these rights and the principles of antidiscrimination on which they were based be exercised? Would sexual minorities be able to participate on an equal footing in the public sphere? Given this region’s long history of feigned compliance with the agenda of larger powers—which was abundantly clear under communism but also under imperial rule prior to World War I—there were abundant grounds for skepticism."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-73",
      "id": "chapter2_73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])]), _vm._v(" It is precisely this tension between the minority-rights commitments that countries made as EU applicants and how some of them behaved as EU members that is captured in the book’s opening epigraphs. Second, what would become of the activist organizations that had benefited from the accession process? Here, too, were grounds for concern: the loss of the role of broker, the tendency of transnational advocacy networks to move on to “needier cases” after states graduate to the EU club, and the background constant of low levels of civic participation in postcommunist societies. Finally, what would be the response of LGBT-rights opponents, especially as EU leverage weakened? Here, this chapter’s findings that the EU’s positive effects on rights are visible primarily when its leverage is maximal (i.e., in "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("potential")]), _vm._v(" member states) foreshadowed postaccession turbulence in Hungary and Poland—closed societies where hard-right breakthrough coincided with weakening EU leverage.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("As "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter1"
    }
  }, [_vm._v("Chapter 1")]), _vm._v(" argued, the catalyst for Poland’s renewed mobilization was the onset of hard-right backlash in the postaccession environment. This backlash reflected the logic of EU leverage (or rather the diminution of such leverage) and so can be understood in terms of how external incentives reshape the domestic POS. Beyond this insight, however, more work is needed by Europeanization scholars to explain contentious politics and activist organization after membership."), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-74",
      "id": "chapter2_74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])]), _vm._v(" Scholars of the transnational diffusion of LGBT rights such "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_56",
      "title": "56"
    }
  }, [_vm._v("as Ayoub have noted the linkage between new rights and new forms of contention: “Even if this international visibility [for gay rights] is at first negatively received and domestically contested, it can still be politically effectual by virtue of creating a legitimizing discourse.”"), _c('span', {
    staticClass: "en-ref"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter2-75",
      "id": "chapter2_75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])]), _vm._v(" The following chapters push this insight further: domestic movements become more organized not “even if” international visibility produces backlash but “especially if.”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5747e2e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter2.vue
// module id = 81
// module chunks = 0